import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ListGroup, Badge } from 'react-bootstrap';
import { 
  FaUser, FaUsers, FaFileInvoice, FaDollarSign, 
  FaUserAlt, FaAddressCard, FaCreditCard, FaExternalLinkAlt 
} from 'react-icons/fa';
import './SearchResults.css';

const SearchResults = ({ results, onResultClick }) => {
  const navigate = useNavigate();

  // Get icon based on item type
  const getIcon = (type) => {
    switch(type) {
      case 'DSO':
        return <FaUsers className="search-result-icon" />;
      case 'Agent':
        return <FaUser className="search-result-icon" />;
      case 'Invoice':
        return <FaFileInvoice className="search-result-icon" />;
      case 'Payout':
        return <FaDollarSign className="search-result-icon" />;
      case 'Lead':
        return <FaAddressCard className="search-result-icon" />;
      case 'Product':
        return <FaCreditCard className="search-result-icon" />;
      default:
        return <FaExternalLinkAlt className="search-result-icon" />;
    }
  };
  
  // Get badge color based on item type
  const getBadgeVariant = (type) => {
    switch(type) {
      case 'DSO':
        return 'primary';
      case 'Agent':
        return 'success';
      case 'Invoice':
        return 'warning';
      case 'Payout':
        return 'info';
      case 'Lead':
        return 'secondary';
      case 'Product':
        return 'dark';
      default:
        return 'light';
    }
  };

  // Handle result click
  const handleItemClick = (item) => {
    if (onResultClick) {
      onResultClick();
    }
    
    if (item.url) {
      navigate(item.url);
    }
  };

  // Group results by type for better organization
  const groupedResults = results.reduce((acc, result) => {
    if (!acc[result.type]) {
      acc[result.type] = [];
    }
    acc[result.type].push(result);
    return acc;
  }, {});

  // If no results, show message
  if (results.length === 0) {
    return (
      <div className="search-no-results">
        <p>No results found</p>
      </div>
    );
  }

  return (
    <div className="search-results">
      {Object.keys(groupedResults).map(type => (
        <div key={type} className="search-result-group">
          <h6 className="search-result-type">
            {type}s ({groupedResults[type].length})
          </h6>
          <ListGroup>
            {groupedResults[type].map(item => (
              <ListGroup.Item 
                key={`${item.type}-${item.id}`}
                action
                className="search-result-item"
                onClick={() => handleItemClick(item)}
              >
                <div className="search-result-content">
                  <div className="search-result-icon-wrapper">
                    {getIcon(item.type)}
                  </div>
                  <div className="search-result-text">
                    <div className="search-result-title">{item.title}</div>
                    {item.description && (
                      <div className="search-result-description">{item.description}</div>
                    )}
                  </div>
                  <Badge bg={getBadgeVariant(item.type)} className="search-result-badge">
                    {item.type}
                  </Badge>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </div>
      ))}
    </div>
  );
};

export default SearchResults;